import en from "./en";
import ru from "./ru";
import tr from "./tr";

const locales = {
  EN: en,
  RU: ru,
  TR: tr
};

const mergeLocale = (base, target = {}) =>
  Object.entries(base).reduce((result, [key, value]) => {
    const targetValue = target[key];

    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      typeof value !== "function"
    ) {
      result[key] = mergeLocale(value, targetValue);
      return result;
    }

    result[key] = targetValue ?? value;
    return result;
  }, {});

export const getLocale = (language) => {
  const code = typeof language === "string" ? language : language?.value;
  return mergeLocale(en, locales[String(code || "EN").toUpperCase()] || en);
};

export default locales;
